import useCachedQuery from '@gef-ui/middleware-api/hooks/useCachedQuery';
import { getRequestCache } from '@gef-ui/middleware-api/redux/cache/selectors';
import getRestUrl from "@gef-ui/utils/getRestUrl";
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
const getCachedItem = createSelector([
    getRequestCache,
    (_state, tryFindValueInCache, value, name, endpoint, format, valuePropName)=>({
            tryFindValueInCache,
            value,
            name,
            endpoint,
            format,
            valuePropName
        })
], ({ cache }, { tryFindValueInCache, value, name, endpoint, format, valuePropName })=>{
    if (!tryFindValueInCache) {
        return null;
    }
    return Object.entries(cache).filter(([key])=>key.startsWith(getRestUrl(endpoint, {
            routeParams: {
                name
            }
        }))).map(([, { data }])=>format({
            data: data.body
        })).flat().find((item)=>item[valuePropName] === value) ?? null;
});
export const useQueryCodelistData = ({ endpoint, name, routeParams = {}, keepPreviousData, filterPathParam, filterValue, waitForFilterValue, searchPathParam, searchValue, urlParams, cacheKey, enabled = waitForFilterValue ? !!filterValue : true, filterValueLocation = 'path', queryOptions = {}, tryFindValueInCache, value, valuePropName, format })=>{
    const query = useCachedQuery({
        endpoint,
        routeParams: {
            name,
            [filterPathParam]: filterValueLocation === 'route' ? filterValue : undefined,
            ...routeParams
        },
        pathVariables: {
            [filterPathParam]: filterValueLocation === 'path' ? filterValue : undefined,
            [searchPathParam]: searchValue
        },
        urlParams: {
            [filterPathParam]: filterValueLocation === 'query' ? filterValue : undefined,
            ...urlParams || {}
        },
        keepPreviousData,
        enabled,
        cacheKey,
        ...queryOptions
    });
    const cachedItem = useSelector((state)=>{
        return getCachedItem(state, tryFindValueInCache, value, name, endpoint, format, valuePropName);
    });
    return {
        ...query,
        cachedItem
    };
};
export default {
    CodelistCore: {
        useQueryCodelistData
    }
};
